// // import React, { useState, useEffect } from 'react';
// // import { Link, useLocation } from 'react-router-dom';

// // const Navbar = () => {
// //   const [isScrolled, setIsScrolled] = useState(false);
// //   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
// //   const location = useLocation();

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setIsScrolled(window.scrollY > 50);
// //     };
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   useEffect(() => {
// //     setIsMobileMenuOpen(false);
// //   }, [location]);

// //   const navLinks = [
// //     { name: 'Home', path: '/' },
// //     { name: 'About Us', path: '/about' },
// //     { name: 'Projects', path: '/projects' },
// //     { name: 'Gallery', path: '/gallery' },
// //   ];

// //   return (
// //     <nav
// //       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
// //         isScrolled
// //           ? 'bg-luxury-dark/95 backdrop-blur-lg shadow-lg py-4'
// //           : 'bg-transparent py-6'
// //       }`}
// //     >
// //       <div className="container mx-auto px-4 lg:px-8">
// //         <div className="flex items-center justify-between">
// //           {/* Logo */}
// //           <Link to="/" className="flex flex-col group">
// //             <span className="text-3xl lg:text-4xl font-serif font-bold text-luxury-accent tracking-[0.15em] group-hover:text-luxury-primary transition-colors duration-300">
// //               NIHIRA
// //             </span>
// //             <span className="text-[0.65rem] font-sans font-light text-luxury-white tracking-[0.3em] uppercase ml-0.5 opacity-90">
// //               REALTORS LLP
// //             </span>
// //           </Link>

// //           {/* Desktop Navigation */}
// //           <div className="hidden lg:flex items-center gap-12">
// //             {navLinks.map((link) => (
// //               <Link
// //                 key={link.path}
// //                 to={link.path}
// //                 className={`relative text-sm font-medium uppercase tracking-wider transition-colors duration-300 ${
// //                   location.pathname === link.path
// //                     ? 'text-luxury-accent'
// //                     : 'text-luxury-white hover:text-luxury-accent'
// //                 }`}
// //               >
// //                 {link.name}
// //                 <span
// //                   className={`absolute -bottom-1 left-0 h-0.5 bg-luxury-accent transition-all duration-300 ${
// //                     location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'
// //                   }`}
// //                 />
// //               </Link>
// //             ))}
// //             <Link
// //               to="/contact"
// //               className="px-6 py-3 bg-luxury-accent text-luxury-white text-sm font-medium uppercase tracking-wider rounded hover:bg-luxury-primary transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
// //             >
// //               Contact Us
// //             </Link>
// //           </div>

// //           {/* Mobile Menu Button */}
// //           <button
// //             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
// //             className="lg:hidden flex flex-col gap-1.5 p-2"
// //             aria-label="Toggle menu"
// //           >
// //             <span
// //               className={`w-6 h-0.5 bg-luxury-white transition-all duration-300 ${
// //                 isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
// //               }`}
// //             />
// //             <span
// //               className={`w-6 h-0.5 bg-luxury-white transition-all duration-300 ${
// //                 isMobileMenuOpen ? 'opacity-0' : ''
// //               }`}
// //             />
// //             <span
// //               className={`w-6 h-0.5 bg-luxury-white transition-all duration-300 ${
// //                 isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
// //               }`}
// //             />
// //           </button>
// //         </div>
// //       </div>

// //       {/* Mobile Menu */}
// //       <div
// //         className={`lg:hidden fixed top-0 right-0 h-screen w-full max-w-sm bg-luxury-dark shadow-2xl transition-transform duration-300 ${
// //           isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
// //         }`}
// //       >
// //         <div className="flex flex-col gap-6 p-8 pt-24">
// //           {navLinks.map((link) => (
// //             <Link
// //               key={link.path}
// //               to={link.path}
// //               className={`text-lg font-medium uppercase tracking-wider transition-colors ${
// //                 location.pathname === link.path
// //                   ? 'text-luxury-accent'
// //                   : 'text-luxury-white hover:text-luxury-accent'
// //               }`}
// //             >
// //               {link.name}
// //             </Link>
// //           ))}
// //           <Link
// //             to="/contact"
// //             className="mt-4 px-6 py-3 bg-luxury-accent text-luxury-white text-center text-sm font-medium uppercase tracking-wider rounded hover:bg-luxury-primary transition-colors"
// //           >
// //             Contact Us
// //           </Link>
// //         </div>
// //       </div>
// //     </nav>
// //   );
// // };

// // export default Navbar;


// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';

// const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     setIsMobileMenuOpen(false);
//   }, [location]);

//   const navLinks = [
//     { name: 'HOME', path: '/' },
//     { name: 'OUR STORY', path: '/about' },
//     { name: 'OUR COLLECTION', path: '/projects' },
//     { name: 'BLOG', path: '/gallery' },
//     { name: 'CONTACT US', path: '/contact' },
//   ];

//   return (
//     <nav className="w-full bg-white border-b border-[#E5E5E5]">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8">
//         <div className="relative flex flex-col items-center py-2 md:py-3">

//           {/* Logo */}
//           <Link to="/" className="mb-1 md:mb-2">
//             <img
//               src="https://nihirarealtors.com/images/logo/nihira.png"
//               alt="Nihira Realtors LLP"
//               className="w-48 md:w-56 h-auto object-contain"
//             />
//           </Link>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex items-center space-x-12">
//             {navLinks.map((link) => {
//               const isActive = location.pathname === link.path;

//               return (
//                 <Link
//                   key={link.path}
//                   to={link.path}
//                   className={`
//                     text-xs font-medium tracking-[0.15em]
//                     transition-all duration-300
//                     ${
//                       isActive
//                         ? 'text-[#B17C00] border-b-2 border-[#B17C00] pb-1'
//                         : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                     }
//                   `}
//                 >
//                   {link.name}
//                 </Link>
//               );
//             })}
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             className="md:hidden absolute right-6 top-4"
//             aria-label="Toggle Menu"
//           >
//             <svg
//               className="w-6 h-6 text-[#1E1B1A]"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               {isMobileMenuOpen ? (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               ) : (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//               )}
//             </svg>
//           </button>

//         </div>
//       </div>

//       {/* Mobile Navigation */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden border-t border-[#E5E5E5] bg-white">
//           <div className="flex flex-col items-center space-y-4 py-4">
//             {navLinks.map((link) => {
//               const isActive = location.pathname === link.path;

//               return (
//                 <Link
//                   key={link.path}
//                   to={link.path}
//                   className={`
//                     text-sm font-medium tracking-wider transition-colors duration-300
//                     ${
//                       isActive
//                         ? 'text-[#B17C00]'
//                         : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                     }
//                   `}
//                 >
//                   {link.name}
//                 </Link>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;




// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';

// const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isProjectsDropdownOpen, setIsProjectsDropdownOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     setIsMobileMenuOpen(false);
//     setIsProjectsDropdownOpen(false);
//   }, [location]);

//   const navLinks = [
//     { name: 'HOME', path: '/' },
//     { name: 'OUR STORY', path: '/about' },
//     { 
//       name: 'OUR PROJECTS', 
//       path: '/projects',
//       hasDropdown: true,
//       subLinks: [
//         // { name: 'All Projects', path: '/projects' },
//         { name: 'The Crown Villas', path: '/crown-villas' },
//         { name: 'Royal Oak Estates', path: '/royal-oak-estates' },
//       ]
//     },
//     { name: 'GALLERY', path: '/gallery' },
//     { name: 'CONTACT US', path: '/contact' },
//   ];

//   return (
//     <nav className="w-full bg-white border-b border-[#E5E5E5]">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8">
//         <div className="relative flex flex-col items-center py-2 md:py-3">

//           {/* Logo */}
//           <Link to="/" className="mb-1 md:mb-2">
//             <img
//               src="https://nihirarealtors.com/images/logo/nihira.png"
//               alt="Nihira Realtors LLP"
//               className="w-48 md:w-56 h-auto object-contain"
//             />
//           </Link>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex items-center space-x-12">
//             {navLinks.map((link) => {
//               const isActive = location.pathname === link.path || 
//                 (link.subLinks && link.subLinks.some(sub => sub.path === location.pathname));

//               if (link.hasDropdown) {
//                 return (
//                   <div 
//                     key={link.path}
//                     className="relative group"
//                     onMouseEnter={() => setIsProjectsDropdownOpen(true)}
//                     onMouseLeave={() => setIsProjectsDropdownOpen(false)}
//                   >
//                     <Link
//                       to={link.path}
//                       className={`
//                         text-xs font-medium tracking-[0.15em]
//                         transition-all duration-300 flex items-center gap-1
//                         ${
//                           isActive
//                             ? 'text-[#B17C00] border-b-2 border-[#B17C00] pb-1'
//                             : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                         }
//                       `}
//                     >
//                       {link.name}
//                       <svg 
//                         className={`w-3 h-3 transition-transform duration-300 ${isProjectsDropdownOpen ? 'rotate-180' : ''}`}
//                         fill="none" 
//                         stroke="currentColor" 
//                         viewBox="0 0 24 24"
//                       >
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                       </svg>
//                     </Link>

//                     {/* Dropdown Menu */}
//                     <div className={`
//                       absolute top-full left-1/2 transform -translate-x-1/2 mt-2
//                       bg-white border border-[#E5E5E5] rounded-sm shadow-xl
//                       w-64 py-2
//                       transition-all duration-300 origin-top
//                       ${isProjectsDropdownOpen ? 'opacity-100 visible scale-100' : 'opacity-0 invisible scale-95'}
//                     `}>
//                       {link.subLinks.map((subLink) => (
//                         <Link
//                           key={subLink.path}
//                           to={subLink.path}
//                           className={`
//                             block px-6 py-3 text-sm font-medium tracking-wider
//                             transition-all duration-200
//                             ${
//                               location.pathname === subLink.path
//                                 ? 'text-[#B17C00] bg-[#B17C00]/5'
//                                 : 'text-[#1E1B1A] hover:text-[#B17C00] hover:bg-[#B17C00]/5'
//                             }
//                           `}
//                         >
//                           {subLink.name}
//                         </Link>
//                       ))}
//                     </div>
//                   </div>
//                 );
//               }

//               return (
//                 <Link
//                   key={link.path}
//                   to={link.path}
//                   className={`
//                     text-xs font-medium tracking-[0.15em]
//                     transition-all duration-300
//                     ${
//                       isActive
//                         ? 'text-[#B17C00] border-b-2 border-[#B17C00] pb-1'
//                         : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                     }
//                   `}
//                 >
//                   {link.name}
//                 </Link>
//               );
//             })}
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             className="md:hidden absolute right-6 top-4"
//             aria-label="Toggle Menu"
//           >
//             <svg
//               className="w-6 h-6 text-[#1E1B1A]"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               {isMobileMenuOpen ? (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               ) : (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//               )}
//             </svg>
//           </button>

//         </div>
//       </div>

//       {/* Mobile Navigation */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden border-t border-[#E5E5E5] bg-white">
//           <div className="flex flex-col items-center space-y-4 py-4">
//             {navLinks.map((link) => {
//               const isActive = location.pathname === link.path;

//               if (link.hasDropdown) {
//                 return (
//                   <div key={link.path} className="w-full">
//                     <button
//                       onClick={() => setIsProjectsDropdownOpen(!isProjectsDropdownOpen)}
//                       className={`
//                         w-full text-center text-sm font-medium tracking-wider transition-colors duration-300 py-2
//                         ${isActive ? 'text-[#B17C00]' : 'text-[#1E1B1A] hover:text-[#B17C00]'}
//                       `}
//                     >
//                       {link.name}
//                     </button>
//                     {isProjectsDropdownOpen && (
//                       <div className="flex flex-col items-center space-y-2 mt-2 pb-2 border-b border-[#E5E5E5]">
//                         {link.subLinks.map((subLink) => (
//                           <Link
//                             key={subLink.path}
//                             to={subLink.path}
//                             className={`
//                               text-xs font-medium tracking-wider transition-colors duration-300
//                               ${
//                                 location.pathname === subLink.path
//                                   ? 'text-[#B17C00]'
//                                   : 'text-[#1E1B1A]/70 hover:text-[#B17C00]'
//                               }
//                             `}
//                           >
//                             {subLink.name}
//                           </Link>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 );
//               }

//               return (
//                 <Link
//                   key={link.path}
//                   to={link.path}
//                   className={`
//                     text-sm font-medium tracking-wider transition-colors duration-300
//                     ${
//                       isActive
//                         ? 'text-[#B17C00]'
//                         : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                     }
//                   `}
//                 >
//                   {link.name}
//                 </Link>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;


// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';

// const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isProjectsDropdownOpen, setIsProjectsDropdownOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     setIsMobileMenuOpen(false);
//     setIsProjectsDropdownOpen(false);
//   }, [location]);

//   const navLinks = [
//     { name: 'HOME', path: '/' },
//     { name: 'OUR STORY', path: '/about' },
//     { 
//       name: 'OUR PROJECTS', 
//       path: '/projects',
//       hasDropdown: true,
//       subLinks: [
//         { name: 'The Crown Villas', path: '/crown-villas' },
//         { name: 'Royal Oak Estates', path: '/royal-oak-estates' },
//       ]
//     },
//     { name: 'GALLERY', path: '/gallery' },
//     { name: 'CONTACT US', path: '/contact' },
//   ];

//   return (
//     <nav className="w-full bg-white border-b border-[#E5E5E5] relative z-50">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8">
//         <div className="relative flex flex-col items-center py-6 md:py-8">

//           {/* Premium Logo with Effects */}
//           <Link to="/" className="mb-4 md:mb-6 group relative">
//             <div className="relative">
//               {/* Animated Background Glow */}
//               <div className="absolute inset-0 bg-gradient-to-r from-[#B17C00] via-[#D4AF37] to-[#B17C00] opacity-0 group-hover:opacity-20 blur-2xl transition-all duration-700 animate-pulse"></div>
              
//               {/* Shimmer Effect */}
//               <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-0 group-hover:opacity-100 transform -skew-x-12 group-hover:translate-x-full transition-all duration-1000"></div>
              
//               {/* Logo Image */}
//               <img
//                 src="https://nihirarealtors.com/images/logo/nihira.png"
//                 alt="Nihira Realtors LLP"
//                 className="w-72 md:w-96 h-auto object-contain relative z-10 transform group-hover:scale-105 transition-all duration-500 filter group-hover:brightness-110"
//               />
              
//               {/* Bottom Shine */}
//               <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//             </div>
//           </Link>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex items-center space-x-10 lg:space-x-14">
//             {navLinks.map((link) => {
//               const isActive = location.pathname === link.path || 
//                 (link.subLinks && link.subLinks.some(sub => sub.path === location.pathname));

//               if (link.hasDropdown) {
//                 return (
//                   <div 
//                     key={link.path}
//                     className="relative group"
//                     onMouseEnter={() => setIsProjectsDropdownOpen(true)}
//                     onMouseLeave={() => setIsProjectsDropdownOpen(false)}
//                   >
//                     <Link
//                       to={link.path}
//                       className={`
//                         text-xs font-semibold tracking-[0.15em] uppercase
//                         transition-all duration-300 flex items-center gap-1
//                         relative py-2
//                         ${
//                           isActive
//                             ? 'text-[#B17C00]'
//                             : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                         }
//                       `}
//                     >
//                       {link.name}
//                       <svg 
//                         className={`w-3.5 h-3.5 transition-transform duration-300 ${isProjectsDropdownOpen ? 'rotate-180' : ''}`}
//                         fill="none" 
//                         stroke="currentColor" 
//                         viewBox="0 0 24 24"
//                       >
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
//                       </svg>
                      
//                       {/* Premium Underline Effect */}
//                       <span className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transition-all duration-300 ${
//                         isActive ? 'w-full' : 'w-0 group-hover:w-full'
//                       }`}></span>
//                     </Link>

//                     {/* Premium Dropdown Menu */}
//                     <div className={`
//                       absolute top-full left-1/2 transform -translate-x-1/2 mt-4
//                       bg-white border border-[#E5E5E5] rounded-md
//                       w-72 py-3
//                       transition-all duration-300 origin-top
//                       backdrop-blur-sm
//                       ${isProjectsDropdownOpen ? 'opacity-100 visible scale-100 translate-y-0' : 'opacity-0 invisible scale-95 -translate-y-2'}
//                     `}
//                     style={{
//                       boxShadow: '0 10px 40px rgba(177, 124, 0, 0.15), 0 0 1px rgba(0,0,0,0.1)'
//                     }}
//                     >
//                       {/* Premium Arrow */}
//                       <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white border-l border-t border-[#E5E5E5] rotate-45"></div>
                      
//                       <div className="relative z-10 bg-white rounded-md overflow-hidden">
//                         {link.subLinks.map((subLink, index) => (
//                           <Link
//                             key={subLink.path}
//                             to={subLink.path}
//                             className={`
//                               block px-6 py-4 text-sm font-semibold tracking-wider
//                               transition-all duration-300 relative overflow-hidden group/item
//                               ${
//                                 location.pathname === subLink.path
//                                   ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5'
//                                   : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                               }
//                               ${index !== link.subLinks.length - 1 ? 'border-b border-[#E5E5E5]/50' : ''}
//                             `}
//                           >
//                             {/* Premium Hover Background */}
//                             <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover/item:translate-x-0 transition-transform duration-300"></span>
                            
//                             <span className="relative z-10 flex items-center justify-between">
//                               {subLink.name}
//                               <svg 
//                                 className={`w-4 h-4 transform transition-transform duration-300 ${
//                                   location.pathname === subLink.path ? 'translate-x-0 opacity-100' : '-translate-x-2 opacity-0 group-hover/item:translate-x-0 group-hover/item:opacity-100'
//                                 }`}
//                                 fill="none" 
//                                 stroke="currentColor" 
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                               </svg>
//                             </span>
//                           </Link>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 );
//               }

//               return (
//                 <Link
//                   key={link.path}
//                   to={link.path}
//                   className={`
//                     text-xs font-semibold tracking-[0.15em] uppercase
//                     transition-all duration-300 relative py-2 group
//                     ${
//                       isActive
//                         ? 'text-[#B17C00]'
//                         : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                     }
//                   `}
//                 >
//                   {link.name}
                  
//                   {/* Premium Underline Effect */}
//                   <span className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transition-all duration-300 ${
//                     isActive ? 'w-full' : 'w-0 group-hover:w-full'
//                   }`}></span>
//                 </Link>
//               );
//             })}
//           </div>

//           {/* Premium Mobile Menu Button */}
//           <button
//             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             className="md:hidden absolute right-6 top-8 p-2.5 rounded-lg transition-all duration-300 hover:bg-gradient-to-r hover:from-[#B17C00]/10 hover:to-[#D4AF37]/10 group border border-transparent hover:border-[#B17C00]/20"
//             aria-label="Toggle Menu"
//           >
//             <svg
//               className="w-6 h-6 text-[#1E1B1A] group-hover:text-[#B17C00] transition-colors duration-300"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               {isMobileMenuOpen ? (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
//               ) : (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 6h16M4 12h16M4 18h16" />
//               )}
//             </svg>
//           </button>

//         </div>
//       </div>

//       {/* Premium Mobile Navigation */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden border-t border-[#E5E5E5] bg-white relative overflow-hidden">
//           {/* Decorative Background */}
//           <div className="absolute inset-0 bg-gradient-to-b from-[#B17C00]/5 via-white to-[#D4AF37]/5 opacity-50"></div>
          
//           {/* Decorative Corners */}
//           <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-[#B17C00]/10 to-transparent rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-[#D4AF37]/10 to-transparent rounded-full blur-3xl"></div>
          
//           <div className="relative z-10 flex flex-col py-6 px-4">
//             {navLinks.map((link, index) => {
//               const isActive = location.pathname === link.path;

//               if (link.hasDropdown) {
//                 return (
//                   <div key={link.path} className="w-full mb-2">
//                     <button
//                       onClick={() => setIsProjectsDropdownOpen(!isProjectsDropdownOpen)}
//                       className={`
//                         w-full text-left text-sm font-semibold tracking-wider uppercase transition-all duration-300 py-4 px-6
//                         relative overflow-hidden group rounded-lg
//                         ${isActive ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5' : 'text-[#1E1B1A] hover:text-[#B17C00]'}
//                       `}
//                     >
//                       {/* Animated Background */}
//                       <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                      
//                       <span className="relative z-10 flex items-center justify-between">
//                         <span>{link.name}</span>
//                         <svg 
//                           className={`w-4 h-4 transition-transform duration-300 ${isProjectsDropdownOpen ? 'rotate-180' : ''}`}
//                           fill="none" 
//                           stroke="currentColor" 
//                           viewBox="0 0 24 24"
//                         >
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
//                         </svg>
//                       </span>
                      
//                       {/* Bottom Border */}
//                       <span className={`absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transform origin-left transition-transform duration-300 ${
//                         isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
//                       }`}></span>
//                     </button>
                    
//                     {/* Dropdown Items */}
//                     {isProjectsDropdownOpen && (
//                       <div className="mt-2 ml-4 space-y-2 animate-fadeIn">
//                         {link.subLinks.map((subLink) => (
//                           <Link
//                             key={subLink.path}
//                             to={subLink.path}
//                             className={`
//                               block text-xs font-semibold tracking-wider uppercase transition-all duration-300 py-3 px-6
//                               relative overflow-hidden group rounded-lg
//                               ${
//                                 location.pathname === subLink.path
//                                   ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5'
//                                   : 'text-[#1E1B1A]/70 hover:text-[#B17C00]'
//                               }
//                             `}
//                           >
//                             {/* Animated Background */}
//                             <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                            
//                             <span className="relative z-10 flex items-center justify-between">
//                               <span>{subLink.name}</span>
//                               <svg 
//                                 className={`w-3.5 h-3.5 transform transition-all duration-300 ${
//                                   location.pathname === subLink.path ? 'translate-x-0 opacity-100' : '-translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100'
//                                 }`}
//                                 fill="none" 
//                                 stroke="currentColor" 
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                               </svg>
//                             </span>
                            
//                             {/* Left Border */}
//                             <span className={`absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#B17C00] to-[#D4AF37] transform origin-top transition-transform duration-300 ${
//                               location.pathname === subLink.path ? 'scale-y-100' : 'scale-y-0 group-hover:scale-y-100'
//                             }`}></span>
//                           </Link>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 );
//               }

//               return (
//                 <Link
//                   key={link.path}
//                   to={link.path}
//                   className={`
//                     text-sm font-semibold tracking-wider uppercase transition-all duration-300 py-4 px-6
//                     relative overflow-hidden group rounded-lg mb-2
//                     ${
//                       isActive
//                         ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5'
//                         : 'text-[#1E1B1A] hover:text-[#B17C00]'
//                     }
//                   `}
//                 >
//                   {/* Animated Background */}
//                   <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                  
//                   <span className="relative z-10">{link.name}</span>
                  
//                   {/* Bottom Border */}
//                   <span className={`absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transform origin-left transition-transform duration-300 ${
//                     isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
//                   }`}></span>
//                 </Link>
//               );
//             })}
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.3s ease-out;
//         }
//       `}</style>
//     </nav>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../Assets/nihirarealtors logo.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProjectsDropdownOpen, setIsProjectsDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsProjectsDropdownOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'OUR STORY', path: '/about' },
    { 
      name: 'OUR PROJECTS', 
      path: '/projects',
      hasDropdown: true,
      subLinks: [
        { name: 'The Crown Villas', path: '/crown-villas' },
        { name: 'Royal Oak Estates', path: '/royal-oak-estates' },
      ]
    },
    { name: 'GALLERY', path: '/gallery' },
    { name: 'CONTACT US', path: '/contact' },
  ];

  return (
    <nav className="w-full bg-white border-b border-[#E5E5E5] relative z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative flex items-center justify-between py-2 md:py-3 md:flex-col md:items-center">

          {/* Premium Logo with Effects */}
         <Link to="/" className="group relative z-10">
  <div className="relative flex items-center gap-3">
    {/* Animated Background Glow */}
    <div className="absolute inset-0 bg-gradient-to-r from-[#B17C00] via-[#D4AF37] to-[#B17C00] opacity-0 group-hover:opacity-20 blur-2xl transition-all duration-700 animate-pulse"></div>

    {/* Logo Image */}
    <div className="relative flex-shrink-0">
      {/* Shimmer Effect on logo */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-0 group-hover:opacity-100 transform -skew-x-12 group-hover:translate-x-full transition-all duration-1000 z-10"></div>

      <img
        src={logo}
        alt="Nihira Realtors LLP"
       className="w-20 md:w-24 lg:w-28 h-auto object-contain relative z-10 transform group-hover:scale-105 transition-all duration-500 filter group-hover:brightness-110"
      />

      {/* Bottom Shine */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
    </div>

    {/* Brand Text */}
    <div className="relative z-10 flex flex-col leading-tight">
      <span
        className="text-sm md:text-base lg:text-lg font-semibold tracking-widest uppercase text-[#D4AF37] group-hover:brightness-110 transition-all duration-500"
        style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.15em' }}
      >
        Nihira
      </span>
      <span
        className="text-[10px] md:text-xs lg:text-sm tracking-[0.25em] uppercase text-[#B17C00]/80 group-hover:text-[#D4AF37]/90 transition-all duration-500"
        style={{ fontFamily: "'Jost', sans-serif" }}
      >
        Realtors
      </span>
    </div>
  </div>
</Link>
          {/* Premium Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2.5 rounded-lg transition-all duration-300 hover:bg-gradient-to-r hover:from-[#B17C00]/10 hover:to-[#D4AF37]/10 group border border-transparent hover:border-[#B17C00]/20"
            aria-label="Toggle Menu"
          >
            <svg
              className="w-6 h-6 text-[#1E1B1A] group-hover:text-[#B17C00] transition-colors duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10 lg:space-x-14">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || 
                (link.subLinks && link.subLinks.some(sub => sub.path === location.pathname));

              if (link.hasDropdown) {
                return (
                  <div 
                    key={link.path}
                    className="relative group"
                    onMouseEnter={() => setIsProjectsDropdownOpen(true)}
                    onMouseLeave={() => setIsProjectsDropdownOpen(false)}
                  >
                    <Link
                      to={link.path}
                      className={`
                        text-xs font-semibold tracking-[0.15em] uppercase
                        transition-all duration-300 flex items-center gap-1
                        relative py-2
                        ${
                          isActive
                            ? 'text-[#B17C00]'
                            : 'text-[#1E1B1A] hover:text-[#B17C00]'
                        }
                      `}
                    >
                      {link.name}
                      <svg 
                        className={`w-3.5 h-3.5 transition-transform duration-300 ${isProjectsDropdownOpen ? 'rotate-180' : ''}`}
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                      </svg>
                      
                      {/* Premium Underline Effect */}
                      <span className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transition-all duration-300 ${
                        isActive ? 'w-full' : 'w-0 group-hover:w-full'
                      }`}></span>
                    </Link>

                    {/* Premium Dropdown Menu */}
                    <div className={`
                      absolute top-full left-1/2 transform -translate-x-1/2 mt-4
                      bg-white border border-[#E5E5E5] rounded-md
                      w-72 py-3
                      transition-all duration-300 origin-top
                      backdrop-blur-sm
                      ${isProjectsDropdownOpen ? 'opacity-100 visible scale-100 translate-y-0' : 'opacity-0 invisible scale-95 -translate-y-2'}
                    `}
                    style={{
                      boxShadow: '0 10px 40px rgba(177, 124, 0, 0.15), 0 0 1px rgba(0,0,0,0.1)'
                    }}
                    >
                      {/* Premium Arrow */}
                      <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white border-l border-t border-[#E5E5E5] rotate-45"></div>
                      
                      <div className="relative z-10 bg-white rounded-md overflow-hidden">
                        {link.subLinks.map((subLink, index) => (
                          <Link
                            key={subLink.path}
                            to={subLink.path}
                            className={`
                              block px-6 py-4 text-sm font-semibold tracking-wider
                              transition-all duration-300 relative overflow-hidden group/item
                              ${
                                location.pathname === subLink.path
                                  ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5'
                                  : 'text-[#1E1B1A] hover:text-[#B17C00]'
                              }
                              ${index !== link.subLinks.length - 1 ? 'border-b border-[#E5E5E5]/50' : ''}
                            `}
                          >
                            {/* Premium Hover Background */}
                            <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover/item:translate-x-0 transition-transform duration-300"></span>
                            
                            <span className="relative z-10 flex items-center justify-between">
                              {subLink.name}
                              <svg 
                                className={`w-4 h-4 transform transition-transform duration-300 ${
                                  location.pathname === subLink.path ? 'translate-x-0 opacity-100' : '-translate-x-2 opacity-0 group-hover/item:translate-x-0 group-hover/item:opacity-100'
                                }`}
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </span>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              }

              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`
                    text-xs font-semibold tracking-[0.15em] uppercase
                    transition-all duration-300 relative py-2 group
                    ${
                      isActive
                        ? 'text-[#B17C00]'
                        : 'text-[#1E1B1A] hover:text-[#B17C00]'
                    }
                  `}
                >
                  {link.name}
                  
                  {/* Premium Underline Effect */}
                  <span className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transition-all duration-300 ${
                    isActive ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}></span>
                </Link>
              );
            })}
          </div>

        </div>
      </div>

      {/* Premium Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-[#E5E5E5] bg-white relative overflow-hidden">
          {/* Decorative Background */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#B17C00]/5 via-white to-[#D4AF37]/5 opacity-50"></div>
          
          {/* Decorative Corners */}
          <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-[#B17C00]/10 to-transparent rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-[#D4AF37]/10 to-transparent rounded-full blur-3xl"></div>
          
          <div className="relative z-10 flex flex-col py-6 px-4">
            {navLinks.map((link, index) => {
              const isActive = location.pathname === link.path;

              if (link.hasDropdown) {
                return (
                  <div key={link.path} className="w-full mb-2">
                    <button
                      onClick={() => setIsProjectsDropdownOpen(!isProjectsDropdownOpen)}
                      className={`
                        w-full text-left text-sm font-semibold tracking-wider uppercase transition-all duration-300 py-4 px-6
                        relative overflow-hidden group rounded-lg
                        ${isActive ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5' : 'text-[#1E1B1A] hover:text-[#B17C00]'}
                      `}
                    >
                      {/* Animated Background */}
                      <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                      
                      <span className="relative z-10 flex items-center justify-between">
                        <span>{link.name}</span>
                        <svg 
                          className={`w-4 h-4 transition-transform duration-300 ${isProjectsDropdownOpen ? 'rotate-180' : ''}`}
                          fill="none" 
                          stroke="currentColor" 
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                        </svg>
                      </span>
                      
                      {/* Bottom Border */}
                      <span className={`absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transform origin-left transition-transform duration-300 ${
                        isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                      }`}></span>
                    </button>
                    
                    {/* Dropdown Items */}
                    {isProjectsDropdownOpen && (
                      <div className="mt-2 ml-4 space-y-2 animate-fadeIn">
                        {link.subLinks.map((subLink) => (
                          <Link
                            key={subLink.path}
                            to={subLink.path}
                            className={`
                              block text-xs font-semibold tracking-wider uppercase transition-all duration-300 py-3 px-6
                              relative overflow-hidden group rounded-lg
                              ${
                                location.pathname === subLink.path
                                  ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5'
                                  : 'text-[#1E1B1A]/70 hover:text-[#B17C00]'
                              }
                            `}
                          >
                            {/* Animated Background */}
                            <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                            
                            <span className="relative z-10 flex items-center justify-between">
                              <span>{subLink.name}</span>
                              <svg 
                                className={`w-3.5 h-3.5 transform transition-all duration-300 ${
                                  location.pathname === subLink.path ? 'translate-x-0 opacity-100' : '-translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100'
                                }`}
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </span>
                            
                            {/* Left Border */}
                            <span className={`absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#B17C00] to-[#D4AF37] transform origin-top transition-transform duration-300 ${
                              location.pathname === subLink.path ? 'scale-y-100' : 'scale-y-0 group-hover:scale-y-100'
                            }`}></span>
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }

              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`
                    text-sm font-semibold tracking-wider uppercase transition-all duration-300 py-4 px-6
                    relative overflow-hidden group rounded-lg mb-2
                    ${
                      isActive
                        ? 'text-[#B17C00] bg-gradient-to-r from-[#B17C00]/10 to-[#D4AF37]/5'
                        : 'text-[#1E1B1A] hover:text-[#B17C00]'
                    }
                  `}
                >
                  {/* Animated Background */}
                  <span className="absolute inset-0 bg-gradient-to-r from-[#B17C00]/5 to-[#D4AF37]/5 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                  
                  <span className="relative z-10">{link.name}</span>
                  
                  {/* Bottom Border */}
                  <span className={`absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#B17C00] to-[#D4AF37] transform origin-left transition-transform duration-300 ${
                    isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                  }`}></span>
                </Link>
              );
            })}
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;